/**
 * @warn - this should not exist in the first place, we should get it from the .env, if you can
 * prefer using the overrideValue.
 * @pure - this is a pure function, please inject all input values
 *
 * @param host - should come from `window.location.host`
 * @param overrideValue - should be used with and value that come from .env
 *
 * @warn - for local development you NEED to use thye overrideValue, else you will get api.localhost:<port>
 */
export function getApiBackendDomain(host: string, overrideValue?: string) {
  if (overrideValue) return overrideValue;

  // 'networx.com' -> [networx, com]
  // 'www.networx.com' -> [www, networx, com]
  const parts = host.split('.');

  const isDevEnv = host.includes('nxenv.com') || host.includes('networx.link');
  if ((isDevEnv && parts.length > 3) || (!isDevEnv && parts.length > 2)) {
    // remove first subdomain
    parts.shift()
  }

  return 'api.' + parts.join('.');
}
